import { render } from "./AccountingIndex.vue?vue&type=template&id=897e1ae8"
import script from "./AccountingIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountingIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Accounting/AccountingIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "897e1ae8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('897e1ae8', __exports__)) {
    api.reload('897e1ae8', __exports__)
  }
  
  module.hot.accept("./AccountingIndex.vue?vue&type=template&id=897e1ae8", () => {
    api.rerender('897e1ae8', render)
  })

}


export default __exports__